import config from "config";

export const accountActivationRedirectUrl = () =>
  `${config.redirectUrl}/activeren`;
